export default __webpack_public_path__ + "static/speed-gauge-01-3c3fb28ba351de4f83350af0f356db6e.png";